import { Empty, Modal, Timeline } from 'antd';
import moment from 'moment';
import { ReadOutlined, GlobalOutlined } from '@ant-design/icons';
import { TimetableAcademicCalendarModalProps } from '@modules/timetable';

export const TimetableAcademicCalendarModal = ({
  academicCalendarItems,
  academicCalendarModalVisible,
  setAcademicCalendarModalVisible,
}: TimetableAcademicCalendarModalProps) => {
  return (
    <Modal
      footer={null}
      title="Academic calendar items"
      visible={academicCalendarModalVisible}
      onOk={() => setAcademicCalendarModalVisible(false)}
      onCancel={() => setAcademicCalendarModalVisible(false)}
    >
      {academicCalendarItems ? (
        <Timeline mode="right">
          {academicCalendarItems.length > 0 ? (
            academicCalendarItems?.map((academicCalendarItem) => {
              return (
                <Timeline.Item
                  dot={
                    academicCalendarItem.type === 'academic' ? (
                      <ReadOutlined style={{ fontSize: '16px' }} />
                    ) : (
                      <GlobalOutlined style={{ fontSize: '16px' }} />
                    )
                  }
                  key={academicCalendarItem.id}
                  color={academicCalendarItem.type === 'academic' ? 'blue' : 'green'}
                  label={`${moment(academicCalendarItem.startDate).format('MMM Do YY')} - ${moment(
                    academicCalendarItem.endDate,
                  ).format('MMM Do YY')}`}
                >
                  {academicCalendarItem.name}
                </Timeline.Item>
              );
            })
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No academic calendar items" />
          )}
        </Timeline>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a semester and batch first" />
      )}
    </Modal>
  );
};
